import Login from '_p/user/Login'
import Center from '_p/user/Center'
import Forget from '_p/user/Forget'

export default [
  {
    path: '/',
    name: 'home',
    component: () => import('_p/home/index'),
    meta: {
      title: ''
    }
  },
  {
    path: '/center',
    name: 'center',
    component: Center,
    meta: {
      title: '用户中心'
    }
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      title: 'login'
    }
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('_p/user/register'),
    meta: {
      title: 'register'
    }
  },
  {
    path: '/Forget',
    name: 'Forget',
    component: Forget,
    meta: {
      title: 'Forget'
    }
  },
  {
    path: '/policy',
    name: 'policy',
    component: () => import('_p/user/Policy'),
    meta: {
      title: ''
    }
  },
  {
    path: '/loan',
    name: 'loan',
    component: () => import('_p/loan/index'),
    meta: {
      title: ''
    }
  },
  {
    path: '/upload',
    name: 'upload',
    component: () => import('_p/loan/upload'),
    meta: {
      title: ''
    }
  },
  {
    path: '/result',
    name: 'result',
    component: () => import('_p/loan/result'),
    meta: {
      title: ''
    }
  },
  {
    path: '/bank',
    name: 'bank',
    component: () => import('_p/loan/bank'),
    meta: {
      title: ''
    }
  },
  {
    path: '*',
    name: 'error',
    component: () => import('_p/404'),
    meta: {
      title: 'error'
    }
  }
]
